import { InputField } from 'components/molecules'

const MarketingDiscountBatchExpiredField = () => (
  <InputField
    type='date'
    name='expire_batch_job_at'
    label='Expired Discount Date'
  />
)

export default MarketingDiscountBatchExpiredField
